import { IAPI_AGE007_Response } from "../../../type/apiType";
import { ProcedureName98 } from "../../../assets/data/Constants";

function funInfoBodyList(res: IAPI_AGE007_Response, onLinkClick: any) {
  let bodyList = res.agentAchievementList?.map((item) => [
    {
      children: (item.staffNo ?? "") + ":" + (item.staffName ?? ""),
    },
    {
      children: item.detail,
    },
  ]);

  return bodyList;
}

const getUrlPath = (
  taskType: string,
  applyId?: number,
  businessType?: string,
  isWithholding?: boolean
) => {
  const urlPath = {
    [ProcedureName98["加入届"]]: applyId ? "/SCRC060110" : "/SCRC060108",
    [ProcedureName98["本俸/調整額の更新"]]: "/SCRC060116",
    [ProcedureName98["従業状況の更新"]]: "/SCRC060112",
    [ProcedureName98["配置換え（対象外異動含む）"]]:
      businessType === "JOB-27" ? "/SCRC060103" : "/SCRC060013",
    [ProcedureName98["退職届"]]: applyId ? "/SCRC060120" : "/SCRC060119",
    [ProcedureName98["退職届（施設単位）"]]: "/SCRC060118",
    [ProcedureName98["退職届（添付待ち）"]]: isWithholding
      ? "/SCRC060125"
      : "/SCRC060121",
  } as { [key: string]: string };

  return urlPath[taskType];
};

export { funInfoBodyList, getUrlPath };
